import { render } from "./expertreportdetailseditor.vue?vue&type=template&id=06d27824"
import script from "./expertreportdetailseditor.vue?vue&type=script&lang=js"
export * from "./expertreportdetailseditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__